// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","item":"NotFound_item__1kWFi","smokePath":"NotFound_smokePath__E2nbh","flames":"NotFound_flames__R5aY4"};